import settings from './config.json';
import { parseISO, format } from "date-fns";
const ConfigHolder = {
    api_server: settings.api_server,
    build: settings.build,
    get apiBaseUrl() {
        //@ts-ignore
        return process.env.API_SERVER;
    },
    get tokenString() {
        let _token = JSON.parse(window.localStorage.getItem('token') || '{}');
        return _token === null || _token === void 0 ? void 0 : _token.token;
    },
    get currentUser() {
        let _token = JSON.parse(window.localStorage.getItem('token') || '{}');
        return _token === null || _token === void 0 ? void 0 : _token.currentUser;
    },
    get buildNumber() {
        //@ts-ignore
        let date = parseISO(process.env.BUILD_DATE);
        //@ts-ignore
        return process.env.BUILD_TYPE.concat('.').concat(format(date, 'yy.LLdd.HHmm'));
    }
};
export default ConfigHolder;
